import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.authService.checkAuth().subscribe({
      next: (res) => {
        console.log('Sesión comprobada:', res);
      },
      error: (err) => {
        console.log('Sesión no válida o expirada');
      }
    });
  }
}
